import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import ButtonInput from "@/components/shared/inputs/ButtonInput.vue";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import { computed, inject, onMounted, ref } from "vue";
import { Form } from "vee-validate";
import InlineSvg from "vue-inline-svg";
import { useRoute } from "vue-router";
import router from "@/router";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  RouterName,
  ShowErrorModal,
} from "@/types";
import { useUserStore } from "@/stores/userStore";
import Modal from "@/components/shared/modal/base/Modal.vue";
import { useServiceStore } from "@/stores/serviceStore";


const __default__ = {
  name: "IdAuthentication",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const serviceStore = useServiceStore();

const route = useRoute();
const maskingUsername = route.query.maskingUsername?.toString() ?? "";
const maskingUserphone = route.query.maskingUserphone?.toString() ?? "";
const eziokCertAuthValueEnc =
  route.query.eziokCertAuthValueEnc?.toString() ?? "";

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const verificationGuideImageUrl = computed(
  () => serviceStore.serviceInfo?.verificationGuideImageUrl
);

const loginId = ref("");

const schema = {
  name: "required:이름을",
  loginId: "required:사원번호를",
};

const employeeGuideBtnTitle = computed(() =>
  shouldShowEmployeeGuide.value ? "사원번호 확인 닫기" : "사원번호 확인 열기"
);

const shouldShowEmployeeGuide = ref(false);
const toggleShowEmployeeGuide = () => {
  shouldShowEmployeeGuide.value = !shouldShowEmployeeGuide.value;
};

const shouldShowAlreadySignupMemberModal = ref(false);
const toggleShowAlreadySignupMemberModal = (show: boolean) => {
  shouldShowAlreadySignupMemberModal.value = show;
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const employeeNoVerificationErrorMsg = ref("");
const updateEmployeeNoVerificationErrorMsg = (message: string) => {
  employeeNoVerificationErrorMsg.value = message;
};

const employeeNoVerificationSuccessMsg = ref("");
const updateEmployeeNoVerificationSuccessMsg = (message: string) => {
  employeeNoVerificationSuccessMsg.value = message;
};

const isVerifiedEmployeeNumber = ref(false);

const userName = ref("");
const updateUserName = (name: string) => {
  userName.value = name;
};

const verifyEmployeeNumber = async () => {
  const result = await userStore.verifyEmployeeNumber(
    eziokCertAuthValueEnc,
    loginId.value
  );

  isVerifiedEmployeeNumber.value = result.isSuccess;

  // 이미 가입된 구성원인 경우
  if (result.resultCode === 409000010) {
    toggleShowAlreadySignupMemberModal(true);
    return;
  }

  // 구성원 확인 불가
  if (result.resultCode === 404000102) {
    updateEmployeeNoVerificationSuccessMsg("");
    updateEmployeeNoVerificationErrorMsg(
      "입력하신 정보와 일치하는 구성원이 없습니다."
    );
    return;
  }

  if (!result.isSuccess) {
    handleError("ID 인증 오류", result);
    return;
  }

  updateUserName(result.data?.name ?? "");
  updateEmployeeNoVerificationErrorMsg("");
  updateEmployeeNoVerificationSuccessMsg("인증이 완료되었습니다.");
};

const goToTermsOfUse = () => {
  route.meta.willGoBack = true;
  window.history.go(-2);
};

const goToLogin = () => {
  router.replace({ name: RouterName.Login });
};

const goToSignUp = () => {
  router.push({
    name: RouterName.SignUp,
    query: {
      maskingUsername,
      maskingUserphone,
      loginId: loginId.value,
      eziokCertAuthValueEnc,
      name: userName.value,
    },
  });
};

onMounted(() => {
  route.meta.onBackHandlerList.push(goToTermsOfUse);
});

const __returned__ = { userStore, serviceStore, route, maskingUsername, maskingUserphone, eziokCertAuthValueEnc, showErrorModal, verificationGuideImageUrl, loginId, schema, employeeGuideBtnTitle, shouldShowEmployeeGuide, toggleShowEmployeeGuide, shouldShowAlreadySignupMemberModal, toggleShowAlreadySignupMemberModal, handleError, employeeNoVerificationErrorMsg, updateEmployeeNoVerificationErrorMsg, employeeNoVerificationSuccessMsg, updateEmployeeNoVerificationSuccessMsg, isVerifiedEmployeeNumber, userName, updateUserName, verifyEmployeeNumber, goToTermsOfUse, goToLogin, goToSignUp, NavigationBar, Page, BaseButton, ButtonInput, TextInput, get Form() { return Form }, get InlineSvg() { return InlineSvg }, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})